/**
 *
 * Asynchronously loads the component for ForgotPasswordForm
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { AuthPageLoading } from '../../components/AuthPageLoading/AuthPageLoading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "ForgotPasswordForm" */),
  loading: <AuthPageLoading />
})
